export enum AssigneeActionStatus {
  SUBMIT = 'submit',
  APPROVE = 'approve',
  REJECT = 'reject',
  COMPLETE = 'complete',
}
